/* eslint-disable react/require-default-props */
import React, {CSSProperties, MouseEventHandler} from "react";
import {useAppState} from "@core-ui/app-state-provider";
import {Brands} from "@core-ui/utility";

const {useLocalize} =
  typeof __USE_I18N__ === "undefined"
    ? require("@core-ui/localization-provider")
    : require("@core-ui/i18n");

const ATPrev = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <g fill="#666" fillRule="nonzero">
        <path
          d="m5.7466 1.4116 6.3207 6.2259c0.19673 0.19378 0.19912 0.51035 0.0053436 0.70709-0.0017663 0.0017933-0.0035462 0.0035732-0.0053395 0.0053396l-0.2757 0.27254c-0.023185 0.02956-0.04827 0.058121-0.075259 0.085519-0.0035328 0.0035865-0.0070926 0.0071463-0.010679 0.010679l-5.9591 5.8697c-0.38927 0.38343-1.0142 0.38343-1.4035-8.1e-6l-0.048724-0.047995c-0.39346-0.38757-0.39824-1.0207-0.010671-1.4142 0.0035328-0.0035865 0.0070926-0.0071463 0.010679-0.010679l5.1926-5.1157-5.1926-5.1154c-0.39346-0.38756-0.39825-1.0207-0.010687-1.4142l0.010679-0.010679 0.048724-0.047994c0.38926-0.38343 1.0142-0.38344 1.4035-8.06e-6z"
          transform="translate(8 8) scale(1 -1) rotate(180) translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

const ATNext = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <g fill="#666" fillRule="nonzero" transform="translate(-10)">
        <path
          d="m15.747 1.4116 6.3207 6.2259c0.19673 0.19378 0.19912 0.51035 0.0053436 0.70709-0.0017663 0.0017933-0.0035462 0.0035732-0.0053395 0.0053396l-0.2757 0.27254c-0.023185 0.02956-0.04827 0.058121-0.075259 0.085519-0.0035328 0.0035865-0.0070926 0.0071463-0.010679 0.010679l-5.9591 5.8697c-0.38927 0.38343-1.0142 0.38343-1.4035-8.1e-6l-0.048724-0.047995c-0.39346-0.38757-0.39824-1.0207-0.010671-1.4142 0.0035328-0.0035865 0.0070926-0.0071463 0.010679-0.010679l5.1926-5.1157-5.1926-5.1154c-0.39346-0.38756-0.39825-1.0207-0.010687-1.4142l0.010679-0.010679 0.048724-0.047994c0.38926-0.38343 1.0142-0.38344 1.4035-8.06e-6z"
          transform="translate(18 8) scale(1 -1) translate(-18 -8)"
        />
      </g>
    </g>
  </svg>
);

const BRPrev = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <g fill="#000" fillRule="nonzero">
        <path
          d="m4.6809 1 6.2791 6.315 0.040285-0.0393 0.68089 0.69332-0.035174 0.035979 0.0094013 0.0095159-0.68089 0.69332-0.013513-0.014837-6.2543 6.2905-0.68089-0.69332 6.2492-6.2862-6.275-6.3107 0.68089-0.69332z"
          transform="translate(7.8406 7.9918) scale(-1 1) translate(-7.8406 -7.9918)"
        />
      </g>
    </g>
  </svg>
);

const BRNext = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <g fill="#000" fillRule="nonzero" transform="translate(0 1)">
        <g>
          <path d="m4.6809 5.2125e-14 6.2761 6.312 0.023882-0.023982 0.68089 0.69332-0.01977 0.019661 0.013401 0.013516-0.68089 0.69332-0.017513-0.018837-6.2697 6.3069-0.68089-0.69332 6.2656-6.3015-6.272-6.3077 0.68089-0.69332z" />
        </g>
      </g>
    </g>
  </svg>
);

const CBPrev = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <path
        d="m5.0357 1 5.9043 5.956 0.024309-0.024575 1.0314 1.0439-0.022731 0.02172 0.027 0.02772-1.0314 1.0439-0.028578-0.029575-5.9086 5.961-1.0314-1.0439 5.907-5.9591-5.9027-5.9531 1.0314-1.0439z"
        fill="#000"
        fillRule="nonzero"
        transform="translate(8 8) scale(1 -1) rotate(180) translate(-8 -8)"
      />
    </g>
  </svg>
);

const CBNext = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <path
        d="m5.0357 1 5.9043 5.956 0.024309-0.024575 1.0314 1.0439-0.022731 0.02172 0.027 0.02772-1.0314 1.0439-0.028578-0.029575-5.9086 5.961-1.0314-1.0439 5.907-5.9591-5.9027-5.9531 1.0314-1.0439z"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const GapPrev = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <path
        d="m5.0357 1 5.9043 5.956 0.024309-0.024575 1.0314 1.0439-0.022731 0.02172 0.027 0.02772-1.0314 1.0439-0.028578-0.029575-5.9086 5.961-1.0314-1.0439 5.907-5.9591-5.9027-5.9531 1.0314-1.0439z"
        fill="#000"
        fillRule="nonzero"
        transform="translate(8 8) scale(1 -1) rotate(180) translate(-8 -8)"
      />
    </g>
  </svg>
);

const GapNext = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <path
        d="m5.0357 1 5.9043 5.956 0.024309-0.024575 1.0314 1.0439-0.022731 0.02172 0.027 0.02772-1.0314 1.0439-0.028578-0.029575-5.9086 5.961-1.0314-1.0439 5.907-5.9591-5.9027-5.9531 1.0314-1.0439z"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const ONPrev = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <g fill="#043863" fillRule="nonzero">
        <path
          d="m5.0448 0.56483 7.388 7.4288-0.0065536 0.006174 0.0065536 0.0065151-7.388 7.4288-1.4776-1.4858 5.916-5.9496-5.916-5.9492 1.4776-1.4858z"
          transform="translate(8 8) scale(1 -1) rotate(180) translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

const ONNext = (
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeWidth="1">
      <g fill="#043863" fillRule="nonzero">
        <path
          d="m5.0448 0.56483 7.388 7.4288-0.0067768 0.0053445 0.0067768 0.0073445-7.388 7.4288-1.4776-1.4858 5.9168-5.9494-5.9168-5.9494 1.4776-1.4858z"
          transform="translate(8 8) scale(1 -1) translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

type Arrows = {
  prev: JSX.Element;
  next: JSX.Element;
};

type ArrowCollection = {
  [x in Brands]: Arrows;
} & {cb: Arrows};

const baseArrows = {
  [Brands.Athleta]: {
    prev: ATPrev,
    next: ATNext,
  },
  [Brands.BananaRepublic]: {
    prev: BRPrev,
    next: BRNext,
  },
  cb: {
    prev: CBPrev,
    next: CBNext,
  },
  [Brands.Gap]: {
    prev: GapPrev,
    next: GapNext,
  },
  [Brands.OldNavy]: {
    prev: ONPrev,
    next: ONNext,
  },
} as ArrowCollection;

export const ArrowButton = ({
  type,
  currentSlide,
  slideCount,
  className,
  onArrowClick,
  ...props
}: {
  currentSlide?: string;
  slideCount?: string;
  type: "prev" | "next";
  "data-role"?: string;
  className?: string;
  style?: CSSProperties;
  onArrowClick?: MouseEventHandler;
  onClick?: MouseEventHandler;
}): JSX.Element => {
  const {localize} = useLocalize();
  const {brandName} = useAppState();
  const arrows = baseArrows[brandName] ?? baseArrows.cb;
  const prevArrowAriaLabel = localize("fui.swatches.prev_button_aria_label");
  const nextArrowAriaLabel = localize("fui.swatches.next_button_aria_label");
  const isNotInteractive = className?.includes("slick-disabled");

  return (
    <button
      aria-hidden={isNotInteractive}
      aria-label={type === "prev" ? prevArrowAriaLabel : nextArrowAriaLabel}
      className={className}
      css={{
        width: "20px",
        height: "20px",
        "&.slick-prev": {transform: "translate(0, -50%)"},
        "&.slick-next": {transform: "translate(0, -50%)"},
        "&.slick-prev, &.slick-next": {
          "&:focus, &:hover": {
            color: "transparent",
            outline: "none",
            background: "transparent",
            "&:before": {
              opacity: "1",
            },
          },
          "&.slick-disabled:before": {
            opacity: "0.25",
          },
        },
        "&.slick-arrow::before": {
          content: "''",
        },
        "&.slick-arrow:focus:not(:active)": {
          boxShadow: "0 0 0 3px #5cabf7",
        },
        "&.slick-prev.slick-disabled": {
          opacity: 0.25,
          cursor: "default",
        },
        "&.slick-next.slick-disabled": {
          opacity: 0,
          cursor: "default",
        },
      }}
      data-current-slide={currentSlide}
      data-slide-count={slideCount}
      disabled={isNotInteractive}
      type="button"
      {...props}
      onClick={(e) => {
        onArrowClick?.(e);
        props.onClick?.(e);
      }}
    >
      {arrows[type]}
    </button>
  );
};
